import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { enqueueSnackbar } from 'notistack';

import { getResolvedEndpoint } from '@/api/utils/getResolvedEndpoint';
import { handleApiCall } from '@/api/utils/handleApiCall';
import { MutationStateFns } from '@/api/utils/mutation';
import { Uuid } from '@/api/utils/sql';
import { useAuth } from '@/context/AuthProvider';

const METHOD = 'DELETE';
const ENDPOINT = 'vault/documents';

export type ApiResponse_Delete_VaultDocument = {
  id: Uuid;
};

export type ApiRequest_Delete_VaultDocument = {
  documentId: string;
};

export const useDeleteVaultDocument = (
  stateFns?: MutationStateFns<ApiResponse_Delete_VaultDocument>
) => {
  const { session } = useAuth();

  return useMutation({
    mutationFn: async (data: ApiRequest_Delete_VaultDocument) =>
      handleApiCall<ApiResponse_Delete_VaultDocument, ApiRequest_Delete_VaultDocument>(
        session,
        METHOD,
        getResolvedEndpoint(`${ENDPOINT}/${data.documentId}`, {}),
        data
      ),
    onSuccess: data => {
      enqueueSnackbar('Document deleted successfully', { variant: 'success' });

      stateFns?.onSuccess?.(data);
    },
    onError: (err: AxiosError) => {
      enqueueSnackbar('Failed to delete document.', { variant: 'error' });
      stateFns?.onError?.(err);
    },
  });
};
